import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import TeamSupportHeader from 'team/components/support/TeamSupportHeader';
import TeamWhiteBackgroundContainer from 'team/components/support/TeamWhiteBackgroundContainer';
import TeamContactUs from 'team/components/support/TeamContactUs';
import TeamRequestAFeatureModal from 'team/components/support/TeamRequestAFeatureModal';
import NotificationSnackbar from 'components/common/notification/NotificationSnackbar';

const TeamSupportContainer = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleSnackbarClose = () => {
        setSnackbar(prev => ({ ...prev, open: false }));
    };

    const handleSubmitSuccess = () => {
        setSnackbar({
            open: true,
            message: 'Feature request sent successfully!',
            severity: 'success'
        });
    };

    const handleSubmitError = (errorMessage) => {
        setSnackbar({
            open: true,
            message: errorMessage,
            severity: 'error'
        });
    };

    const handleInteractiveOnboarding = () => {
        navigate('/team/members');
    };

    return (
        <>
            <TeamSupportHeader
                onInteractiveOnboarding={handleInteractiveOnboarding}
                onRequestFeature={handleOpenModal}
            />

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                }}
            >
                <TeamWhiteBackgroundContainer>
                    <TeamContactUs />
                </TeamWhiteBackgroundContainer>
            </Box>

            <TeamRequestAFeatureModal
                open={isModalOpen}
                onClose={handleCloseModal}
                onSubmitSuccess={handleSubmitSuccess}
                onSubmitError={handleSubmitError}
            />

            <NotificationSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                handleClose={handleSnackbarClose}
            />
        </>
    );
};

export default TeamSupportContainer;
